function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import classNames from 'classnames';
import { isEmpty, sumBy, upperCase } from 'lodash';
import T from 'prop-types';
import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import List from '../../../../components/list/List';
import { softwares } from '../../../../components/mapView/constants';
import Activity from '../../../../components/timeline/Activity';
import { DEFAULT_CURRENCY, GST } from '../../../../constants/price';
import { ADD_ONS_DATA_TYPE, BUY_NOW_DATA_TYPES, CAPTURE_SCAN_SERVICES_DATA_TYPE, PRODUCT_TYPE } from '../../../../constants/product';
import text, { formatCurrency } from '../../../../text';
import RfqCard from './Card';
var RequestForQuote = function(param) {
    var title = param.title, job = param.job, rfqCharges = param.rfqCharges;
    var _softwares_entities_job_customer_software;
    var quote = job.quote;
    var _ref = quote || {
        currency: DEFAULT_CURRENCY,
        gst: GST
    }, currency = _ref.currency, gst = _ref.gst;
    var chargesHasTbc = useMemo(function() {
        var _quote_charges;
        return quote === null || quote === void 0 ? void 0 : (_quote_charges = quote.charges) === null || _quote_charges === void 0 ? void 0 : _quote_charges.some(function(param) {
            var details = param.details;
            return [
                PRODUCT_TYPE.UNKNOWN
            ].includes(details.delivery_method);
        });
    }, [
        quote === null || quote === void 0 ? void 0 : quote.charges
    ]);
    var siteDeploymentFee = useMemo(function() {
        var deploymentFee = quote === null || quote === void 0 ? void 0 : quote.fees.find(function(fee) {
            return fee.id === 'site_deployment_fee';
        });
        if (deploymentFee && deploymentFee.price.total === text('toBeConfirmed')) {
            return text('toBeConfirmed');
        }
        return deploymentFee === null || deploymentFee === void 0 ? void 0 : deploymentFee.price.total;
    }, [
        quote === null || quote === void 0 ? void 0 : quote.fees
    ]);
    var totalDiscount = useMemo(function() {
        return sumBy(rfqCharges, function(charge) {
            return sumBy(charge.discounts, function(discount) {
                return discount.price.discount;
            });
        });
    }, [
        rfqCharges
    ]);
    var totalPrice = useMemo(function() {
        return sumBy(rfqCharges, function(charge) {
            return charge.price.base;
        });
    }, [
        rfqCharges
    ]);
    var subTotal = useMemo(function() {
        var deploymentFee = siteDeploymentFee === text('toBeConfirmed') ? 0 : siteDeploymentFee;
        return totalPrice + deploymentFee - totalDiscount;
    }, [
        siteDeploymentFee,
        totalDiscount,
        totalPrice
    ]);
    var totalGst = subTotal * (gst / 100);
    var grandTotal = subTotal + totalGst;
    var software = ((_softwares_entities_job_customer_software = softwares.entities[job.customer_software]) === null || _softwares_entities_job_customer_software === void 0 ? void 0 : _softwares_entities_job_customer_software.name) || null;
    var rfqOrders = useMemo(function() {
        var filteredData = {
            dbData: rfqCharges.filter(function(charge) {
                return BUY_NOW_DATA_TYPES.includes(charge.details.category_name);
            }),
            tripodData: rfqCharges.filter(function(charge) {
                return CAPTURE_SCAN_SERVICES_DATA_TYPE.includes(charge.details.category_name);
            }),
            addOnsData: rfqCharges.filter(function(charge) {
                return ADD_ONS_DATA_TYPE.includes(charge.details.category_name);
            })
        };
        return {
            lhs: [
                {
                    header: text('dataInDatabase'),
                    data: filteredData.dbData,
                    isSiteDeploymentFeeShown: false
                },
                {
                    header: text('getQuote3dScanCaptureServices'),
                    data: filteredData.tripodData,
                    isSiteDeploymentFeeShown: true
                }
            ].filter(function(param) {
                var data = param.data;
                return data.length > 0;
            }),
            rhs: [
                {
                    header: 'Add ons',
                    data: filteredData.addOnsData,
                    isSiteDeploymentFeeShown: false
                }
            ].filter(function(param) {
                var data = param.data;
                return data.length > 0;
            })
        };
    }, [
        rfqCharges
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "InvoiceActivity"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-2 font-weight--600 font-18"
    }, /*#__PURE__*/ React.createElement(Activity.Card.Type, {
        type: title
    })), /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 font-weight--400 font-16"
    }, text('buyItems', {
        title: upperCase(text('getQuote'))
    })), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        lg: 12,
        xl: 6,
        className: "quote-card mb-3 pr-xl-0"
    }, !isEmpty(rfqOrders) && rfqOrders.lhs.map(function(order, index) {
        if (isEmpty(order.data)) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(RfqCard, _object_spread({
            key: index,
            index: index,
            quote: quote,
            order: order
        }, order.isSiteDeploymentFeeShown && {
            siteDeploymentFee: siteDeploymentFee
        }));
    })), /*#__PURE__*/ React.createElement(Col, {
        lg: 12,
        xl: 6,
        className: "quote-card mb-3"
    }, !isEmpty(rfqOrders) && rfqOrders.rhs.map(function(order, index) {
        if (isEmpty(order.data)) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(RfqCard, _object_spread({
            key: index,
            index: rfqOrders.lhs.length,
            quote: quote,
            order: order
        }, order.isSiteDeploymentFeeShown && {
            siteDeploymentFee: siteDeploymentFee
        }));
    }))), /*#__PURE__*/ React.createElement("hr", {
        className: "totals-divider mb-0"
    }), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        lg: 12,
        xl: 6,
        className: "pr-xl-0"
    }, /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "InvoiceTotal"
    }, totalDiscount ? /*#__PURE__*/ React.createElement(List.Item, {
        description: text('discounts'),
        value: "-".concat(formatCurrency(totalDiscount, currency.name, currency.scale_factor, {}, true)),
        key: "invoice-discounts",
        className: "discounts"
    }) : /*#__PURE__*/ React.createElement("div", {
        className: "mb-2"
    }), /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        className: classNames({
            isApproximate: !chargesHasTbc && !isNaN(subTotal)
        }),
        description: text('subtotal'),
        value: chargesHasTbc ? text('toBeConfirmed') : isNaN(subTotal) ? text('toBeConfirmed') : formatCurrency(subTotal, currency.name, currency.scale_factor, {}, true),
        key: "invoice-subtotal"
    }), /*#__PURE__*/ React.createElement(List.Item, {
        className: classNames({
            isApproximate: !chargesHasTbc && !isNaN(totalGst)
        }),
        description: text('gst'),
        value: chargesHasTbc ? text('toBeConfirmed') : isNaN(totalGst) ? text('toBeConfirmed') : formatCurrency(totalGst, currency.name, currency.scale_factor, {}, true),
        key: "invoice-gst"
    }), /*#__PURE__*/ React.createElement(List.Item, {
        className: classNames({
            isApproximate: !chargesHasTbc && !isNaN(grandTotal)
        }),
        isHighlighted: true,
        description: text('total'),
        key: "invoice-total",
        value: chargesHasTbc ? text('toBeConfirmed') : isNaN(grandTotal) ? text('toBeConfirmed') : formatCurrency(grandTotal, currency.name, currency.scale_factor, {}, true)
    }))))), /*#__PURE__*/ React.createElement("p", {
        className: "pt-1 mb-3 grey-3"
    }, text('rfqNote')), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 mt-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "font-weight-bold"
    }, text('software'), ": "), /*#__PURE__*/ React.createElement("span", null, software, " ")), /*#__PURE__*/ React.createElement("div", {
        className: "terms-and-conditions"
    }, text('orderSubjectAgreement', {
        link: /*#__PURE__*/ React.createElement(Link, {
            key: "urlTerms",
            to: {
                pathname: process.env.LARKI_URL_TERMS
            },
            target: "_blank"
        }, "Customer ", text('termsAndConditions'))
    })));
};
RequestForQuote.propTypes = {
    title: T.string,
    job: T.object,
    quote: T.object,
    rfqCharges: T.array
};
export default RequestForQuote;
